import React, { useEffect, useMemo, useState } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Divider, FormControl, FormHelperText, Grid, IconButton, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, Tooltip, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { createPlatform, deletePlatformSetting, updatePlatform } from '../../store/platformSlice';
import CommentDrawer from '../Common/Drawer';
import { AVAILABLE_INTEGRATIONS, COMMON_PLATFROM_SETTINGS, FACEBOOK_FEED_TYPE, INSTAGRAM_FEED_TYPE, REDDIT_FEED_TYPE, YOUTUBE_FEED_TYPE, YOUTUBE_PLATFROM_SETTINGS } from '../../utils/constant';
import _, { set } from 'lodash';
import { CloseRounded, Facebook } from '@mui/icons-material';
import { fetchDomainList, fetchDomains } from '../../store/domainSlice';
import { InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { fetchCookies, fetchinstagramAC, fetchRedditAC, fetchYoutubes } from '../../store/cookieSlice';

export default function PlatformForm({ page, setPage, getPlatfroms, title, platformModal, setPlatformModal, resetTrigger, selectedPlatform = null }) {
    const dispatch = useDispatch();
    const [removedKeyPairs, setRemovedKeyPairs] = useState([]);
    const [searchTags, setSearchTags] = useState([]);

    const [isButtonDisabled, setIsButtonDisabled] = React.useState();
    const [allIndustryIds, setAllIndustryIds] = React.useState([]);
    const [platformsetting, setPlatformsetting] = React.useState(COMMON_PLATFROM_SETTINGS);
    const [allFeedTypeIds, setAllFeedTypeIds] = React.useState([]);
    const [feedType, setFeedType] = React.useState(FACEBOOK_FEED_TYPE);
    const industries = useSelector((state) => state.industryReducer.industryList)
    const domains = useSelector((state) => state.domainReducer.domainList)
    const allOptionId = 'all';
    const allOptionLabel = 'All';

    // Account state selectors
    const cookies = useSelector((state) => state.cookieReducer.cookies);
    const instagramAC = useSelector((state) => state.cookieReducer.instagramAC);
    const redditAC = useSelector((state) => state.cookieReducer.redditAC);
    const youtubes = useSelector((state) => state.cookieReducer.youtubes);
    const cookieLoading = useSelector((state) => state.cookieReducer.loading);

    // Account list based on integration

    const validationSchemaSchemaWithContext = () =>
        Yup.object({
            name: Yup.string()
                .min(1)
                .max(50, "Name cannot exceed 50 characters").
                required("Name is required"),
            description: Yup.string().min(1).max(200, "Description cannot exceed 200 characters").required("Description is required"),
            integration: Yup.string().required("Integration is required"),
            industry_id: Yup.string().required("Industry is required"),
            domain_ids: Yup.array().required("Domain is required"),
            feed_type: Yup.array().when('integration', {
                is: (val) => val === 'Facebook',
                then: (schema) => schema.required('Feed Type is required'),
                otherwise: (schema) => schema.notRequired(),
            }),
            settings: Yup.array().of(
                Yup.object().shape({
                    key: Yup.string().required("Key is required"),
                    // value: Yup.mixed()
                    //     .test("required-or-tags", `${key} is required`, function (val) {
                    //         const { key } = this.parent;
                    //         if (key === "SEARCH_KEYWORD") {
                    //             return (searchTags?.length > 0) || !!val;
                    //         }

                    //         return !!val;
                    //     })
                        value: Yup.mixed().test("required-or-tags", function (val) {
                            const { key ,name} = this.parent;
                          
                            if (key === "SEARCH_KEYWORD") {
                              const isValid = (searchTags?.length > 0) || !!val;
                              if (!isValid) {
                                return this.createError({ message: `${name} is required` });
                              }
                              return true;
                            }
                          
                            if (!val) {
                              return this.createError({ message: `${name} is required` });
                            }
                          
                            return true;
                          })
                        .test("max-25-words-if-text", "Value must not exceed 25 Characters", function (val) {
                            const { value_type } = this.parent;
                            if (value_type === "text" && typeof val === "string") {
                                return val?.length <= 25;
                            }
                            return true;
                        })
                        .test("max-5-tags", "A maximum of 5 tags are allowed", function () {
                            const { key } = this.parent;
                            const { value_type } = this.parent;
                            if (key === "SEARCH_KEYWORD") {
                                return searchTags?.length < 5;
                            }
                            return true;
                        }),
                    value_type: Yup.string().required("Value type is required"),
                })
            ),
            // account_id: Yup.string().required('Account is required'),
        });


    const formik = useFormik({
        initialValues: {
            name: "",
            description: "",
            integration: "",
            industry_id: "",
            feed_type: [],
            domain_ids: [],
            domain_counts: {},
            settings: platformsetting,
            // account_id: '',
        },
        validationSchema: () => validationSchemaSchemaWithContext(),
        onSubmit: async (values) => {
            const filteredFeedTypes = values.feed_type.filter((type) => type !== 'all');
            const feedVal = filteredFeedTypes.join(',');
            const domainsPayload = Object.entries(formik.values.domain_counts).map(([domainId, maxCount]) => ({
                domain_id: parseInt(domainId),
                max_count: parseInt(maxCount),
            }));
            const forData = {
                ...values, domains: domainsPayload, feed_type: feedVal, settings: values.settings.map((ele) => {
                    // if (ele.key === "API_KEY") {
                    //     console.log("ele.value", ele.value);
                    //     const encrypted = encrypt(ele.value);
                    //     return { ...ele, value: encrypted }
                    // }
                    if (ele.key === "SEARCH_KEYWORD") {

                        if (searchTags.length < 5)
                            // return { ...ele, value: searchTags.join(',') + (ele.value ? `,${ele.value}` : "") }
                            return {
                                ...ele,
                                value: searchTags.length
                                    ? searchTags.join(',') + (ele.value ? `,${ele.value}` : '')
                                    : (ele.value ? `${ele.value}` : '')
                            }
                        else
                            return { ...ele, value: searchTags.join(',') }

                    } else {
                        return ele;
                    }

                })
            };

            setPlatformModal(false);

            if (selectedPlatform) {
                forData.id = selectedPlatform.uuid;
                dispatch(updatePlatform(forData)).then(() => {
                    getPlatfroms()
                })
                if (removedKeyPairs.length) {
                    removedKeyPairs.map((ele) => {
                        dispatch(deletePlatformSetting({ id: selectedPlatform.id, settingId: ele.id }))
                    })
                }
            } else {
                forData.SCROLL_PAUSE = 1.5
                dispatch(createPlatform(forData)).then((res) => {
                    if (page) {
                        setPage(0)
                    } else {
                        getPlatfroms()
                    }
                })
            }
        },
    });
    const accountList = React.useMemo(() => {
        switch (formik.values.integration) {
            case 'Facebook':
                return cookies;
            case 'Instagram':
                return instagramAC;
            case 'Reddit':
                return redditAC;
            case 'YouTube':
                return youtubes;
            default:
                return [];
        }
    }, [formik.values.integration, cookies, instagramAC, redditAC, youtubes]);
    
    useEffect(() => {
        if (selectedPlatform?.name && platformModal) {
            const updatedSettings = selectedPlatform?.settings.map(setting =>
                setting.key === "SEARCH_KEYWORD"
                    ? { ...setting, value: "" }
                    : setting
            );
            setSearchTags(selectedPlatform?.settings?.find(ele => ele.key === "SEARCH_KEYWORD")?.value?.split(',') || [])

            let domain_counts = {}
            let domain_ids = []
            if (selectedPlatform?.domains?.length) {
                const selectedDomains = selectedPlatform?.domains.map((ele) => ele.domain?.id)
                const isAll = _.isEqual([...selectedDomains].sort(), [...allIndustryIds].sort())
                domain_counts = selectedPlatform.domains.reduce((accumulator, current) => {
                    const domainId = current.domain.id;
                    const maxCount = current.max_count;
                    accumulator[domainId] = maxCount;
                    return accumulator;
                }, {});


                const domainsData = selectedPlatform.domains.map((ele) => ele?.domain?.id)
                domain_ids = isAll ? ["all", ...domainsData] : domainsData
            }
            formik.setValues({
                name: selectedPlatform.name,
                description: selectedPlatform.description,
                settings: updatedSettings || [{ key: "", value: "" }],
                integration: selectedPlatform?.integration,
                domain_counts,
                domain_ids,
                industry_id: selectedPlatform?.industry?.id,
                feed_type: selectedPlatform?.feed_type?.split(',') || [],
            });
        } else {
            formik.resetForm();
            setSearchTags([]);
        }
    }, [selectedPlatform, platformModal, resetTrigger]);


    useEffect(() => {
        if (selectedPlatform?.name) {
            const originalSettings = selectedPlatform.settings
            const currentSettings = formik.values.settings.map(setting => {
                if (setting.key === "SEARCH_KEYWORD") {
                    return { ...setting, value: searchTags.join(',') };
                }
                return setting;
            });
            const isSettingsEqual = _.isEqual(originalSettings, currentSettings);
            const compareVal = {
                name: selectedPlatform.name,
                description: selectedPlatform.description,
                integration: selectedPlatform.integration,
                industry_id: selectedPlatform?.industry?.id,
                domain_ids: selectedPlatform?.domain?.id || "",
                feed_type: selectedPlatform?.feed_type?.split(',') || [],
            };
            const currentFormValues = {
                name: formik.values.name,
                description: formik.values.description,
                integration: formik.values.integration,
                industry_id: formik.values.industry_id,
                domain_ids: formik.values.domain_ids,
                feed_type: formik.values.feed_type,
            };
            const isOtherFieldsEqual = _.isEqual(compareVal, currentFormValues);
            // Final decision
            setIsButtonDisabled(isSettingsEqual && isOtherFieldsEqual);
        }
    }, [selectedPlatform, formik.values, searchTags, domains]);


    useEffect(() => {
        if (formik.values.industry_id) {
            dispatch(fetchDomainList(`&industry_ids=${formik.values.industry_id} `))
        }
        if (formik.values.industry_id !== selectedPlatform?.industry?.id) {
            formik.setFieldValue('domain_ids', []);
            formik.setFieldValue('domain_counts', {});
        }
    }, [formik.values.industry_id])

    useEffect(() => {
        switch (formik.values.integration) {
            case "YouTube":
                setFeedType(YOUTUBE_FEED_TYPE)
                setPlatformsetting(YOUTUBE_PLATFROM_SETTINGS)
                formik.setFieldValue('feed_type', YOUTUBE_FEED_TYPE.map((ele) => ele.key))
                break;
            case "Facebook":
                setPlatformsetting(COMMON_PLATFROM_SETTINGS)
                setAllFeedTypeIds(FACEBOOK_FEED_TYPE.map((ele) => ele.key))
                setFeedType(FACEBOOK_FEED_TYPE)
                let feedType = []
                if (selectedPlatform && selectedPlatform?.integration === "Facebook") {
                    feedType = selectedPlatform?.feed_type?.split(',')
                }
                formik.setFieldValue('feed_type', feedType)
                break;
            case "Reddit":
                setPlatformsetting(COMMON_PLATFROM_SETTINGS)
                setFeedType(REDDIT_FEED_TYPE)
                formik.setFieldValue('feed_type', REDDIT_FEED_TYPE.map((ele) => ele.key))
                break;
            case "Instagram":
                setPlatformsetting(COMMON_PLATFROM_SETTINGS)
                setFeedType(INSTAGRAM_FEED_TYPE)
                formik.setFieldValue('feed_type', INSTAGRAM_FEED_TYPE.map((ele) => ele.key))
                break;
            default:
                setPlatformsetting(COMMON_PLATFROM_SETTINGS)
                break;
        }
    }, [formik.values.integration])

    useEffect(() => {
        const allIndustryIds = domains?.map(d => d.id);
        setAllIndustryIds(allIndustryIds)
    }, [domains])

    useEffect(() => {
        if (platformsetting.length) {

            let mergedSettings = [...platformsetting];

            if (selectedPlatform?.settings?.length) {
                const data = mergedSettings.map(element => {
                    const setting = selectedPlatform?.settings.find((item => item.key === element.key))
                    if (setting && setting.key === "SEARCH_KEYWORD") {
                        return { ...setting, value: "" }

                    }
                    else {
                        return setting ? setting : element
                    }
                });
                formik.setFieldValue("settings", data);
            } else {
                formik.setFieldValue("settings", platformsetting);
            }
        }
    }, [platformsetting, selectedPlatform]);

    // Fetch account list on integration change
    useEffect(() => {
        if (!formik.values.integration) return;
        formik.setFieldValue('account_id', '');
        switch (formik.values.integration) {
            case 'Facebook':
                dispatch(fetchCookies());
                break;
            case 'Instagram':
                dispatch(fetchinstagramAC());
                break;
            case 'Reddit':
                dispatch(fetchRedditAC());
                break;
            case 'YouTube':
                dispatch(fetchYoutubes());
                break;
            default:
                break;
        }
    }, [formik.values.integration, dispatch]);
    
    return (
        <CommentDrawer open={platformModal} setOpen={setPlatformModal}>
            <Box className="position-relative h-100">
                <form onSubmit={formik.handleSubmit} >
                    <Typography variant="h6" gutterBottom className='p-3'>
                        {title}
                    </Typography>
                    <Divider />
                    <div className='role-form-scroller px-3'>
                        <TextField
                            fullWidth
                            required
                            id="name"
                            name="name"
                            label="Name"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                        />
                        <TextField
                            fullWidth
                            required
                            id="description"
                            name="description"
                            label="Description"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.description && Boolean(formik.errors.description)}
                            helperText={formik.touched.description && formik.errors.description}
                        />
                        <FormControl fullWidth className='mt-3'
                            error={formik.touched.integration && Boolean(formik.errors.integration)}
                            required
                        >
                            <InputLabel id="integration">Source</InputLabel>
                            <Select
                                labelId="integration"
                                id="integration"
                                name='integration'
                                label="Source"
                                value={formik.values.integration}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.integration && Boolean(formik.errors.integration)}
                                helperText={formik.touched.integration && formik.errors.integration}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                endAdornment={
                                    formik.values.integration ? (
                                        <IconButton
                                            size="small"
                                            className='mr-4'
                                            onClick={() => {
                                                formik.setFieldValue('integration', '');
                                            }}
                                            onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                                        >
                                            <CloseRounded />
                                        </IconButton>
                                    ) : null
                                }
                            >
                                {AVAILABLE_INTEGRATIONS?.length && AVAILABLE_INTEGRATIONS?.map((ele) => <MenuItem value={ele.name}>{ele.name}</MenuItem>)}
                            </Select>
                            {formik.touched.integration && formik.errors.integration && (
                                <FormHelperText className='text-danger'>{formik.errors.integration}</FormHelperText>
                            )}

                        </FormControl>
                        {/* // code for the select account */}
                        {/* <FormControl fullWidth className='mt-4'
                            // required
                            error={formik.touched.account_id && Boolean(formik.errors.account_id)}
                            disabled={!formik.values.integration || cookieLoading}
                        >
                            <InputLabel id="account_id">Account</InputLabel>
                            <Select
                                labelId="account_id"
                                id="account_id"
                                name='account_id'
                                label="Account"
                                value={formik.values.account_id}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                            >
                                {accountList && accountList.length > 0 ? accountList.map((acc) => (
                                    <MenuItem key={acc.id || acc.uuid} value={acc.id || acc.uuid}>
                                        {acc?.app_name || acc?.email }
                                    </MenuItem>
                                )) : (
                                    <MenuItem disabled>No accounts found.</MenuItem>
                                )}
                            </Select>
                            {formik.touched.account_id && formik.errors.account_id && (
                                <FormHelperText className='text-danger'>{formik.errors.account_id}</FormHelperText>
                            )}
                        </FormControl> */}
                        {formik.values.integration === "Facebook" &&
                            <FormControl fullWidth className='mt-4'
                                error={formik.touched.feed_type && Boolean(formik.errors.feed_type)}
                                required
                            >
                                <InputLabel id="integration">Feed Type</InputLabel>
                                <Select
                                    labelId="feed_type"
                                    id="feed_type"
                                    multiple
                                    name="feed_type"
                                    label="Feed Type"
                                    value={formik.values.feed_type}
                                    onChange={(event) => {
                                        const value = event.target.value;

                                        const isAllSelected = formik.values.feed_type.includes(allOptionId);
                                        const justClickedAll = value.includes(allOptionId) && !isAllSelected;
                                        const justUnclickedAll = !value.includes(allOptionId) && isAllSelected;

                                        if (justClickedAll) {
                                            formik.setFieldValue('feed_type', [allOptionId, ...allFeedTypeIds]);
                                        } else if (justUnclickedAll) {
                                            formik.setFieldValue('feed_type', []);
                                        } else {
                                            const filtered = value.filter(val => val !== allOptionId);

                                            if (filtered.length === allFeedTypeIds?.length) {
                                                formik.setFieldValue('feed_type', [allOptionId, ...filtered]);
                                            } else {
                                                formik.setFieldValue('feed_type', filtered);
                                            }
                                        }
                                    }}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                            {selected.filter((id) => id !== allOptionId).map((id) => {
                                                const item = feedType.find((ele) => ele?.key === id);
                                                return (
                                                    <Chip
                                                        className="role-permission mr-2"
                                                        key={id}
                                                        label={item?.name}
                                                        onMouseDown={(e) => e.stopPropagation()}
                                                        onDelete={() => {
                                                            const newSelection = formik.values.feed_type
                                                                .filter(val => val !== id && val !== allOptionId); // remove clicked + "All"
                                                            formik.setFieldValue('feed_type', newSelection);
                                                        }}
                                                    />
                                                );
                                            })}
                                        </Box>
                                    )}
                                >
                                    {feedType.length > 1 && <MenuItem key={allOptionId} value={allOptionId}>
                                        <Checkbox checked={formik.values.feed_type?.includes(allOptionId)} />
                                        <ListItemText primary={allOptionLabel} />
                                    </MenuItem>}

                                    {feedType.map((ele) => (
                                        <MenuItem key={ele.key} value={ele.key}>
                                            <Checkbox checked={formik.values.feed_type?.includes(ele.key)} />
                                            <ListItemText primary={ele.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                {formik.touched.feed_type && formik.errors.feed_type && (
                                    <FormHelperText className='text-danger'>{formik.errors.feed_type}</FormHelperText>
                                )}
                            </FormControl>}
                        <FormControl fullWidth className='mt-4'
                            required
                            error={formik.touched.industry_id && Boolean(formik.errors.industry_id)}
                        >
                            <InputLabel id="industry_id">Industry</InputLabel>
                            <Select
                                labelId="industry_id"
                                id="industry_id"
                                name='industry_id'
                                label="Industry"
                                value={formik.values.industry_id}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.industry_id && Boolean(formik.errors.industry_id)}
                                helperText={formik.touched.industry_id && formik.errors.industry_id}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                endAdornment={
                                    formik.values.industry_id ? (
                                        <IconButton
                                            size="small"
                                            className='mr-4'
                                            onClick={() => {
                                                formik.setFieldValue('industry_id', '');
                                            }}
                                            onMouseDown={(event) => event.stopPropagation()}
                                        >
                                            <CloseRounded />
                                        </IconButton>
                                    ) : null
                                }
                            >
                                {(!industries || industries?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No Industry found.
                                    </MenuItem>
                                )}
                                {industries?.length && industries?.map((ele) => <MenuItem value={ele.id}>{ele.title}</MenuItem>)}
                            </Select>
                            {formik.touched.industry_id && formik.errors.industry_id && (
                                <FormHelperText className='text-danger'>{formik.errors.industry_id}</FormHelperText>
                            )}
                        </FormControl>
                        {formik.values?.domain_ids?.length ? <Grid container spacing={2} className='mt-3'>
                            {formik.values.domain_ids
                                ?.filter((id) => id !== allOptionId)
                                .map((id, index) => {
                                    const domain = domains.find((d) => d.id === id);
                                    return (
                                        domain && (
                                            <>
                                                <Grid item md={8} key={id}>

                                                    <Typography color="primary" variant="body2">
                                                        {index + 1}. {domain.route}
                                                    </Typography>
                                                </Grid>
                                                <Grid item md={3}>
                                                    <TextField
                                                        type="number"
                                                        required
                                                        label="Count"
                                                        variant="outlined"
                                                        size="small"
                                                        inputProps={{ min: 1, max: 100 }}
                                                        fullWidth
                                                        value={formik.values.domain_counts?.[id] || ''}
                                                        onChange={(e) => {
                                                            const newCounts = {
                                                                ...(formik.values.domain_counts || {}),
                                                                [id]: e.target.value,
                                                            };
                                                            formik.setFieldValue('domain_counts', newCounts);
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        error={
                                                            formik.touched.domain_counts?.[id] &&
                                                            Boolean(formik.errors.domain_counts?.[id])
                                                        }
                                                        helperText={
                                                            formik.touched.domain_counts?.[id] &&
                                                            formik.errors.domain_counts?.[id]
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item md={1}>
                                                    <IconButton
                                                        aria-label="delete"
                                                        color="primary"
                                                        onClick={() => {
                                                            // Remove the domain ID from domain_ids
                                                            const updatedDomainIds = formik.values.domain_ids.filter(
                                                                (domainId) => domainId !== id
                                                            );
                                                            formik.setFieldValue('domain_ids', updatedDomainIds);

                                                            // Remove the corresponding entry from domain_counts
                                                            const updatedDomainCounts = { ...formik.values.domain_counts };
                                                            delete updatedDomainCounts[id];
                                                            formik.setFieldValue('domain_counts', updatedDomainCounts);
                                                        }}
                                                    >
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Grid>
                                            </>
                                        )
                                    );
                                })}
                        </Grid> : <></>}

                        {formik.values.industry_id &&
                            <FormControl fullWidth className='mt-4'
                                error={formik.touched.domain_ids && Boolean(formik.errors.domain_ids)}
                                required
                            >
                                <InputLabel id="integration">Domain</InputLabel>
                                <Select
                                    labelId="domain_ids"
                                    id="domain_ids"
                                    multiple
                                    name="domain_ids"
                                    label="Domain"
                                    value={formik.values.domain_ids || []}
                                    onChange={(event) => {
                                        const value = event.target.value;

                                        const isAllSelected = formik.values?.domain_ids?.includes(allOptionId);
                                        const justClickedAll = value.includes(allOptionId) && !isAllSelected;
                                        const justUnclickedAll = !value.includes(allOptionId) && isAllSelected;

                                        if (justClickedAll) {
                                            formik.setFieldValue('domain_ids', [allOptionId, ...allIndustryIds]);
                                        } else if (justUnclickedAll) {
                                            formik.setFieldValue('domain_ids', []);
                                        } else {
                                            const filtered = value.filter(val => val !== allOptionId);

                                            if (filtered.length === allIndustryIds.length) {
                                                formik.setFieldValue('domain_ids', [allOptionId, ...filtered]);
                                            } else {
                                                formik.setFieldValue('domain_ids', filtered);
                                            }
                                        }
                                    }}
                                    renderValue={(selected) => (
                                        <Typography color="primary" className='render-lable' >Domain</Typography>
                                    )}
                                >
                                    {domains?.length ? <MenuItem key={allOptionId} value={allOptionId}>
                                        <Checkbox checked={formik.values.domain_ids?.includes(allOptionId)} />
                                        <ListItemText primary={allOptionLabel} />
                                    </MenuItem>
                                        : (
                                            <MenuItem disabled color="primary">
                                                No domains found.
                                            </MenuItem>
                                        )
                                    }

                                    {domains?.length && domains.map((ele) => (
                                        <MenuItem key={ele.id} value={ele.id}>
                                            <Checkbox checked={formik.values.domain_ids?.includes(ele.id)} />
                                            <ListItemText primary={ele.route} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                {!domains?.length && !formik.values?.domain_ids?.length && <FormHelperText className="text-danger">
                                    No domains found. To create a platform, bind at least one domain to the selected industry.
                                </FormHelperText>}
                                {formik.touched.domain_ids && formik.errors.domain_ids && (
                                    <FormHelperText className='text-danger'>{formik.errors.domain_ids}</FormHelperText>
                                )}
                            </FormControl>}




                        <Box className="mt-2" >
                            {formik.values.settings.map((pair, index) => {
                                const isSearchKey = pair.key === "SEARCH_KEYWORD";
                                let type = pair.value_type

                                return (
                                    <Box key={index} className="d-flex " >
                                        {pair.key === "SEARCH_KEYWORD" ?
                                            <TextField
                                                fullWidth
                                                required={pair.key !== "SEARCH_KEYWORD"}
                                                type={type}
                                                id={`settings.${index}.value`}
                                                name={`settings.${index}.value`}
                                                label={pair.name}
                                                // multiline={pair.key==="SEARCH_KEYWORD"}
                                                // rows={3}
                                                margin="normal"
                                                variant="outlined"
                                                value={pair.value}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}

                                                placeholder={pair.name}
                                                onKeyDown={(e) => {
                                                    e.stopPropagation(); // prevent form submission on Enter key
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault(); // prevent form submission
                                                        const trimmed = pair.value.trim();
                                                        const isDuplicate = searchTags.some(
                                                            tag => tag.toLowerCase() === trimmed.toLowerCase()
                                                        );

                                                        if (!trimmed || isDuplicate) {
                                                            const updated = [...formik.values.settings];
                                                            updated[index].value = "";
                                                            formik.setFieldValue("settings", updated);
                                                            return;
                                                        }
                                                        if (trimmed && trimmed.length <= 26 && !isDuplicate && searchTags?.length < 5) {
                                                            setSearchTags((prev) => [...prev, trimmed]);
                                                            const updated = [...formik.values.settings];
                                                            updated[index].value = "";
                                                            formik.setFieldValue("settings", updated);
                                                            formik.setFieldError(`settings.${index}.value`, undefined); // Clear error if valid
                                                        }
                                                    }
                                                }}
                                                error={
                                                    formik.touched.settings?.[index]?.value &&
                                                    Boolean(formik.errors.settings?.[index]?.value)
                                                }
                                                helperText={
                                                    formik.touched.settings?.[index]?.value &&
                                                    formik.errors.settings?.[index]?.value
                                                }
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        flexWrap: 'wrap',
                                                        alignItems: 'flex-start',
                                                        minHeight: 'auto',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        flexGrow: 1,
                                                        minWidth: 100,
                                                    },
                                                }}
                                                inputProps={{ maxLength: 26 }}
                                                InputProps={
                                                    isSearchKey
                                                        ? {
                                                            startAdornment: (
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        gap: 1,
                                                                        maxWidth: '100%',
                                                                        flex: 1,
                                                                        alignItems: 'center',
                                                                        marginTop: '12px',
                                                                        marginRight: '17px',
                                                                    }}
                                                                >
                                                                    {searchTags?.map((tag, tagIndex) => (
                                                                        <Chip
                                                                            key={tagIndex}
                                                                            label={tag}
                                                                            className='role-permission mr-2'
                                                                            onMouseDown={(e) => e.stopPropagation()}
                                                                            size="small"
                                                                            onDelete={() => {
                                                                                const updatedTags = searchTags.filter((_, i) => i !== tagIndex);
                                                                                setSearchTags(updatedTags);

                                                                            }}
                                                                            sx={{
                                                                                maxWidth: 'calc(100% - 32px)',
                                                                                wordBreak: 'break-word',
                                                                            }}
                                                                        />
                                                                    ))}
                                                                </Box>
                                                            ),
                                                            endAdornment: (
                                                                <InputAdornment position="end" className='plus-button-inside-input'>
                                                                    {searchTags?.length < 5 ?
                                                                        <Button
                                                                            sx={{ height: '22px', width: '10px', minWidth: "34px" }}
                                                                            variant='contained'
                                                                            edge="end"
                                                                            color='primary'
                                                                            size='small'
                                                                            disabled={formik.touched.settings?.[index]?.value &&
                                                                                Boolean(formik.errors.settings?.[index]?.value)}
                                                                            onClick={(e) => {
                                                                                // if (pair.value.trim()) {
                                                                                //     setSearchTags(prev => [...prev, pair.value.trim()]);
                                                                                //     const updated = [...formik.values.settings];
                                                                                //     updated[index].value = "";
                                                                                //     formik.setFieldValue("settings", updated);
                                                                                // }
                                                                                e.preventDefault(); // prevent form submission
                                                                                const trimmed = pair.value.trim();
                                                                                const isDuplicate = searchTags.some(
                                                                                    tag => tag.toLowerCase() === trimmed.toLowerCase()
                                                                                );

                                                                                if (!trimmed || isDuplicate) {
                                                                                    const updated = [...formik.values.settings];
                                                                                    updated[index].value = "";
                                                                                    formik.setFieldValue("settings", updated);
                                                                                    return;
                                                                                }
                                                                                if (trimmed && trimmed.length <= 26 && !isDuplicate && searchTags?.length < 6) {
                                                                                    setSearchTags((prev) => [...prev, trimmed]);
                                                                                    const updated = [...formik.values.settings];
                                                                                    updated[index].value = "";
                                                                                    formik.setFieldValue("settings", updated);
                                                                                    formik.setFieldError(`settings.${index}.value`, undefined); // Clear error if valid
                                                                                }
                                                                            }}
                                                                        >
                                                                            <AddIcon />
                                                                        </Button>
                                                                        :
                                                                        <Tooltip title="Maximum 5 tags allowed" placement="top" arrow>
                                                                            <span>
                                                                                <Button
                                                                                    sx={{ height: '22px', width: '10px', minWidth: "34px", cursor: 'pointer' }}
                                                                                    variant='contained'
                                                                                    edge="end"
                                                                                    color='primary'
                                                                                    size='small'
                                                                                    disabled
                                                                                >
                                                                                    <AddIcon />
                                                                                </Button>
                                                                            </span>
                                                                        </Tooltip>

                                                                    }
                                                                </InputAdornment>
                                                            ),
                                                        }
                                                        : undefined
                                                }
                                            />
                                            :
                                            <TextField
                                                fullWidth
                                                required
                                                type={pair.value_type}
                                                id={`settings.${index}.value`}
                                                name={`settings.${index}.value`}
                                                label={pair.name}
                                                // multiline={pair.key==="SEARCH_KEYWORD"}
                                                // rows={3}
                                                // type={pair.value_type === "password" ? showPassword.password ? "text" : "password" : pair.value_type}
                                                margin="normal"
                                                variant="outlined"
                                                value={pair.value}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                placeholder={pair.name}

                                                // InputProps={{
                                                //     endAdornment: (
                                                //         pair.value_type === "password" && <PasswordVisibility
                                                //             showPassword={showPassword.password}
                                                //             onToggle={() => togglePasswordVisibility("password")}
                                                //         />
                                                //     ),
                                                // }}

                                                error={
                                                    formik.touched.settings?.[index]?.value &&
                                                    Boolean(formik.errors.settings?.[index]?.value)
                                                }
                                                helperText={
                                                    formik.touched.settings?.[index]?.value &&
                                                    formik.errors.settings?.[index]?.value
                                                }
                                            />}
                                    </Box>

                                );
                            })}

                        </Box>
                    </div>
                    <Box className="drawer-footer m-3">
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={() => setPlatformModal(false)}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="mt-2"
                        // disabled={selectedPlatform ? (isButtonDisabled || !formik.isValid) : !(formik.dirty && formik.isValid)}
                        >
                            Save
                        </Button>
                    </Box>
                </form>
            </Box>
        </CommentDrawer>
    );
}